import { render, staticRenderFns } from "./HomeViewPage.vue?vue&type=template&id=31524e1a&scoped=true&"
import script from "./HomeViewPage.vue?vue&type=script&lang=ts&"
export * from "./HomeViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./HomeViewPage.vue?vue&type=style&index=0&id=31524e1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31524e1a",
  null
  
)

export default component.exports